import { unescape } from 'html-escaper';
import { FileModel, ToolCustomerFileCategoryModel, UserModel } from '.';
import { SYSTEM_LANGUAGES } from '../actions/variables';
import { translate } from '../helpers/frontend';

/*
  channel : String
    - C2U
    - Store Code

  mode : Number
    0 = download
    1 = view
    2 = download and view
*/

export class ToolCustomerFileModel {
  constructor(data={}) {
    this._id = data?._id || null;
    
    this.category = new ToolCustomerFileCategoryModel(data.category || {});

    this.name = data.name? unescape(data.name): null;
    this.description = data.description? unescape(data.description): null;

    this.url = data.url || null;
    this.image = new FileModel(data.image || {});
    
    this.files = (data.files || []).map(d => ({
      _id: d._id || null,
      name: d.name || '',
      file: new FileModel(d.file || {}),
      mode: Number(d.mode || 0),
      order: Number(d.order || 1),
    }));

    this.content = data.content? unescape(data.content): null;

    this.startAt = data.startAt || null;
    this.endAt = data.endAt || null;

    this.order = data.order? Number(data.order): 1;
    this.status = data.status? Number(data.status): 0;
    this.type = data.type? Number(data.type): 0;

    this.createdBy = new UserModel(data.createdBy || {});
    this.createdAt = data.createdAt || null;
    this.updatedBy = new UserModel(data.updatedBy || {});
    this.updatedAt = data.updatedAt || null;

    // Localization
    this.localization(data);
  }
  localization(data){
    let self = this;
    self.localizedKeys = [ 'name', 'description', 'content' ];
    SYSTEM_LANGUAGES.forEach(lang => {
      self.localizedKeys.forEach(k => {
        let key = `${k}${lang}`;
        self[key] = data[key]? unescape(data[key]): data[k];
      });
    });
  }

  isValid() { return this._id? true: false; }

  displayStatus(langObj={}) {
    if(this.isValid()){
      if(this.status === 1) return (<span className="ss-tag bg-success">{translate('Active',langObj)}</span>);
      return (<span className="ss-tag bg-fgray color-dark">{translate('Inactive',langObj)}</span>);
    }
    return (<></>);
  }
}